export const LineGuide = {
  title: 'line_status_code',
  subTitle: 'machine_state_info',
  pemeaPna: {
    details: {
      running: {
        title: 'title_running',
        text: 'text_running'
      },
      stopByAlarm: {
        title: 'title_stopped',
        text: 'text_stopped'
      },
      paused: {
        title: 'title_paused',
        text: 'text_paused'
      },
      cleaning: {
        title: 'title_cleaning',
        text: 'text_cleaning'
      },
      idle: {
        title: 'title_idle',
        text: 'text_idle'
      }
    }
  }
  // Other Machine Type info
};
